import { Configuration } from "@/types/crm/configuration/configuration";

export const airtableDefaultConfigurationElements = {
    "parameter": {
        "crm": {
            apiKey: "Api Key",
        },
        "project": {
            baseId: "Base Id",
        },
        "survey": {
            tableName: "Table Name",
        },
        "question": {
            columnName: "Column Name",
        }
    }
} as const

export const airtableDefaultConfiguration: Configuration = {
    "parameter": {
        "crm": [
            {
                "id": airtableDefaultConfigurationElements.parameter.crm.apiKey,
                "name": airtableDefaultConfigurationElements.parameter.crm.apiKey,
                "settings": {
                    "isPrivate": true,
                }
            },
        ],
        "project": [
            {
                "id": airtableDefaultConfigurationElements.parameter.project.baseId,
                "name": airtableDefaultConfigurationElements.parameter.project.baseId
            }
        ],
        "survey": [
            {
                "id": airtableDefaultConfigurationElements.parameter.survey.tableName,
                "name": airtableDefaultConfigurationElements.parameter.survey.tableName
            }
        ],
        "question": [
            {
                "id": airtableDefaultConfigurationElements.parameter.question.columnName,
                "name": airtableDefaultConfigurationElements.parameter.question.columnName,
                "settings": {
                    "isRequiredForExport": true,
                }
            }
        ]
    }
} as const